export const config = {
  logoHeight: "64px",
};
